import _construct from "@babel/runtime/helpers/construct";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import duration from 'dayjs/plugin/duration';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import timezone from 'dayjs/plugin/timezone';
import toArray from 'dayjs/plugin/toArray';
import utc from 'dayjs/plugin/utc';

// Apply extensions
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(toArray);
dayjs.extend(localizedFormat);
dayjs.extend(duration);
dayjs.extend(customParseFormat);
export { dayjs as DayJs };

// "2016-06-30T03:39:34+0000" is not valid date format on safari
// transfer to ISO 8601 date format "2016-06-30T03:39:34+00:00"
export var dateStringReformat = function dateStringReformat(str) {
  if (!str || !dayjs(str).isValid()) return null;
  return dayjs(str).format();
};
export var getTimezone = function getTimezone() {
  return dayjs.tz.guess();
};

// Covert to target timezone and then ignore the converted timezone
export var convertDateTimezone = function convertDateTimezone(date) {
  var timezone = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : getTimezone();
  if (!date || !dayjs(date).isValid()) return dayjs();
  var covert = dayjs(date).tz(timezone);
  return dayjs(_construct(Date, _toConsumableArray(covert.toArray())));
};
export var dateToFormatString = function dateToFormatString(str) {
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'YYYY-MM-DD';
  var isUTC = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  if (!str || !dayjs(str).isValid()) return '';
  var date = dayjs(str);
  if (isUTC) {
    date = date.utc();
  }
  return date.format(format);
};
var trimTimeZone = function trimTimeZone(date, isUTC) {
  var format = 'YYYY-MM-DDTHH:mm:ss.SSSZ';
  var dateStr = isUTC ? dayjs.utc(date).format(format) : dayjs(date).format(format);
  var index = dateStr.lastIndexOf('+') === -1 ? dateStr.lastIndexOf('-') : dateStr.lastIndexOf('+');
  if (index !== -1) {
    return dateStr.slice(0, index);
  } else {
    return dateStr;
  }
};

// ignore the time zone and replace with UTC
export var trimTimezoneAndToUTC = function trimTimezoneAndToUTC(date) {
  if (!date || !dayjs(date).isValid()) return null;
  var ambiguousDate = trimTimeZone(date);
  return dayjs.utc(ambiguousDate).format('YYYY-MM-DDTHH:mm:ss.SSSZ');
};

// replace UTC with local time zone
export var trimTimezoneAndToLocal = function trimTimezoneAndToLocal(date) {
  if (!date || !dayjs(date).isValid()) return null;
  var ambiguousDate = trimTimeZone(date, true);
  return dayjs(ambiguousDate).format('YYYY-MM-DDTHH:mm:ss.SSSZ');
};

// Force use en to format the request header time
export var getTimeForRequestHeader = function getTimeForRequestHeader(date) {
  return (date && dayjs(date).isValid() ? dayjs(date) : dayjs()).locale('en').utc().format('ddd, D MMM YYYY H:mm:ss ZZ');
};
export var dateToISOString = function dateToISOString(date) {
  if (!date || !dayjs(date).isValid()) return null;
  return dayjs(date).utc().toISOString();
};